module.exports = __webpack_public_path__ + "img/max-file-sync.f8304035.svg";